import axios from 'axios'

// axios based fetcher fo swr
export const fetcher = <T>(url: string): Promise<T> =>
    axios.get(url).then((res) => res.data)

export default fetcher
